<template>
  <div class="cabinet-name-wrapper">
    <router-link class="cabinet-name" :to="{ name: 'search', params: { cabinetId: props.cabinetId }}">
      {{ cabinetName }}
    </router-link>
    <span class="cabinet-description"> {{ cabinetDescription }} </span>
  </div>
</template>

<script setup>
  const props = defineProps(['cabinetName', 'cabinetDescription', 'cabinetId'])
</script>

<style scoped lang="scss">
  .cabinet-name-wrapper {
    display: flex;
    flex-direction: column;
  }

  .cabinet-name {
    color: #303030;
  }

  .cabinet-name:hover {
    text-decoration: underline;
  }

  .cabinet-description {
    color: #666
  }
</style>
